@if (myaccountAccountInfo$ | async; as myaccount) {
<div class="myaccount-account-info" [ngClass]="freightPrice && freightPrice !== '$0' ? 'snah' : ''">
  <div class="myaccount-heading">
    <h2>{{ 'myAccount.accountInfo' | cxTranslate }}</h2>
    @if (myaccount?.isB2BAdmin === true && isEditAccountInfoEnabled$ | async) {
    <a [routerLink]="['/my-account/account-information']">
      {{ 'common.edit' | cxTranslate }}
    </a>
    }
  </div>
  <div class="myaccount-wrapper">
    <div class="account-details main-address">
      @if (myaccount?.mainAddress) {
      <h3 class="account-label">
        {{ 'myAccount.mainAddress' | cxTranslate }}
      </h3>
      } @else {
      <h3 class="account-label" [style.height.px]="48"></h3>
      <span class="account-info" [style.width.px]="231">{{ myaccount?.mainAddress?.formattedAddress }}</span>
      }
      <app-tooltip-text
        class="account-info"
        [tooltipContent]="myaccount?.mainAddress?.formattedAddress"
        [content]="showAddress(myaccount?.mainAddress) | async"
        [charactersLimit]="350"
        placement="bottom"
      >
      </app-tooltip-text>
    </div>
    <div class="delivery-address">
      @if (myaccount?.defaultAddress) {
      <h3 class="account-label">
        {{ 'myAccount.defaultDeliveryAddress' | cxTranslate }}
      </h3>
      } @else {
      <h3 class="account-label" [style.height.px]="48"></h3>
      <span class="account-info" [style.width.px]="231">{{ myaccount?.defaultAddress?.formattedAddress }}</span>
      }
      <app-tooltip-text
        class="account-info"
        [tooltipContent]="myaccount?.defaultAddress?.formattedAddress"
        [content]="showAddress(myaccount?.defaultAddress) | async"
        placement="bottom"
      >
      </app-tooltip-text>
    </div>
    <div class="billing-address">
      @if (myaccount?.defaultBillingAddress) {
      <h3 class="account-label">
        {{ 'myAccount.billingAddress' | cxTranslate }}
      </h3>
      } @else {
      <h3 class="account-label" [style.height.px]="48"></h3>
      <span class="account-info" [style.width.px]="231">{{ myaccount?.defaultBillingAddress?.formattedAddress }}</span>
      }
      <app-tooltip-text
        class="account-info"
        [tooltipContent]="myaccount?.defaultBillingAddress?.formattedAddress"
        [content]="showAddress(myaccount?.defaultBillingAddress) | async"
        placement="bottom"
      >
      </app-tooltip-text>
    </div>
  </div>
  @if (freightPrice && freightPrice !== '$0' && showActiveSnahCountry$ | async) {
  <div class="freight">
    <mat-icon svgIcon="freight-icon"></mat-icon>
    <span>{{ 'checkout.group.customFreight.freight' | cxTranslate : { freightLevel: freightPrice } }} </span>
  </div>
  }
</div>
}
